import PlaceSelector from "./PlaceSelector";

export default PlaceSelector;
